const NAME_UTIL = "KibernetesObject";

export default class KibernetesObject {
  #selector;
  #start;
  #elem;

  constructor( params={} ) {
    this.#selector = params.selector;
    this.#start = !KibernetesObject.isUndef( params.start ) ? params.start : document;
    this.#elem = this.#toNodeList( params.element );

    if ( KibernetesObject.isUndef( this.#elem ) ) {
      if ( !KibernetesObject.isUndef( params.selector ) ) {
        this.#elem = this.#start.querySelectorAll( this.#selector );
      }
    }
  }
  #toNodeList( e ){
    let ele;
    if ( !KibernetesObject.isUndef( e ) ) {
      e.setAttribute('kibNodeList','');
      ele = document.querySelectorAll('[kibNodeList]');
      e.removeAttribute('kibNodeList');
    }
    return ele;
  }

  showIfChecked( checkbox ) {
    if ( !this.#isUndefined() ) {
      const me = this;
      if ( checkbox instanceof KibernetesObject ) {
        checkbox.addEventListener( 'change', (event) => {
          if ( event.target.checked ) {
            me.show();
          } else {
            me.hide();
          }
        });
      }
    }
  }
  addClass( css ) {
    if ( !KibernetesObject.isUndef( css ) ) {
      const c = css.split(' ');
      this.#each( (e) => {
        c.forEach( (cls) => {
          e.classList.add( cls );
        });
      });
    }
  }
  removeClass( css ) {
    if ( !KibernetesObject.isUndef( css ) ) {
      const c = css.split(' ');
      this.#each( (e) => {
        c.forEach( (cls) => {
          e.classList.remove( cls );
        });
      });
    }
  }
  addEventListener( eventName, f ) {
    this.#each( (e) => {
      e.addEventListener( eventName, f );
    });
  }
  removeChildren() {
    this.#each( (e) => {
      while( e.firstChild ) {
        e.removeChild( e.firstChild );
      }
    });
  }
  appendChild( child ) {
    let e = this.#first();
    if ( e ) {
      e.appendChild( child );
    };
  }
  children( selector ) {
    let e = this.#first();
    if ( e ) {
      return new KibernetesObject({ selector: selector });
    }
  }
  child( selector ) {
    let e = this.#first();
    if ( e ) {
      return new KibernetesObject({ selector: selector });
    }
  }
  forEach( f ) {
    this.#each( (e) => {
      f( e );
    });
  }
  #first() {
    if ( !this.#isUndefined() ) {
      return this.#elem.item(0);
    }
  }
  #each( f ) {
    if ( !this.#isUndefined() ) {
      this.#elem.forEach( function( e ) {
        f( e );
      });
    }
  }
  hide( cls ) {
    this.#each( (e) => {
      const ko = new KibernetesObject({ element: e });
      ko.addClass('d-none');
      ko.element.style.display='none';
      if ( typeof cls !== 'undefined' ) {
        ko.removeClass(cls);
      }
    });
  }
  dispatchEvent( event ) {
    this.#each( (e) => {
      e.dispatchEvent( event );
    });
  }
  get html() {
    var s = "";
    if ( !this.#isUndefined() ) {
      let e = this.#first();
      s = e.innerHTML;
    }
    return s;
  }
  set html( html ) {
    if ( !this.#isUndefined() ) {
      let e = this.#first();
      e.innerHTML = html;
    }
  }
  show( cls ) {
    this.#each( (e) => {
      const ko = new KibernetesObject({ element: e });
      ko.removeClass('d-none');
      ko.element.style.display='';
      if ( typeof cls !== 'undefined' ) {
        ko.addClass(cls);
      }
    });
  }
  get length() {
    let count = 0;
    this.#each( (e) => {
      count++;
    });
    return count;
  }
  set value( v ) {
    let e = this.#first();
    if ( e ) {
      e.value = v;
    };
  }
  get value() {
    let e = this.#first();
    if ( e ) {
      return e.value;
    };
  }
  get element() {
    let e = this.#first();
    return e;
  }

  #isUndefined() {
    return KibernetesObject.isUndef( this.#elem );
  }
  static isUndef( e ) {
    if ( typeof e === 'undefined' || e === null ) {
      return true;
    }
    return false;
  }
}
